import { render, staticRenderFns } from "./mallUser.vue?vue&type=template&id=fcc965b4&scoped=true"
import script from "./mallUser.vue?vue&type=script&lang=js"
export * from "./mallUser.vue?vue&type=script&lang=js"
import style0 from "./mallUser.vue?vue&type=style&index=0&id=fcc965b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc965b4",
  null
  
)

export default component.exports